import { render, staticRenderFns } from "./ProjectsTable.vue?vue&type=template&id=214b1eee&"
import script from "./ProjectsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('214b1eee')) {
      api.createRecord('214b1eee', component.options)
    } else {
      api.reload('214b1eee', component.options)
    }
    module.hot.accept("./ProjectsTable.vue?vue&type=template&id=214b1eee&", function () {
      api.rerender('214b1eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/ProjectsTable.vue"
export default component.exports